module.exports = __webpack_public_path__ + "static/img/foot_logo.f23af51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot_logo.png
// module id = O0XI
// module chunks = 7